@if (!isWide) {
  <div class="control color-picker no-border" [ngClass]="{ 'is-disabled': disabled }" fxLayout="column" fxLayoutGap="0.5rem">
    <div fxLayout="row" fxLayoutAlign="stretch center">
      <div class="selected-color" [ngStyle]="{ 'background-color': selectedColor || selectedColorMissing }">
      </div>
      <div class="ml-2 selected-color-input">
        <input [disabled]="disabled" class="input" [class.is-error]="hasError" type="text" placeholder="---" [value]="selectedColor"
          (blur)="onSelectedColorChanged($event)" (focus)="hasError = false"/>
      </div>
    </div>
    @if(hasError) {
      <span class="error-message" fxFlex="1">{{ 'COLOR-PICKER.INVALID-COLOR-ERROR' | translate }}</span>
    }
    @if (isInline) {
      <div fxLayout="row" fxLayoutAlign="space-between start" class="color-field">
        @for (colorColumn of colorColumns; track $index) {
          <div fxLayout="column">
            @for (square of colorColumn; track square.color) {
              <div class="square" [ngClass]="square.lightOrDark" (click)="selectColor(square.color)"
                [ngStyle]="{ 'background-color': square.color }">
                @if (selectedColor?.toLowerCase() === square.color.toLowerCase()) {
                  <i class="icon icon-check_clear" [ngClass]="square.lightOrDark"></i>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

@if (isWide) {
  <div class="control color-picker color-picker-wide" [ngClass]="{ 'is-disabled': disabled }">
    <div fxLayout="row"
      fxLayoutAlign="start center">
      <div>
        <div fxLayout="row" class="color-field mr-3">
          @for (colorColumn of colorColumns; track $index) {
            <div fxLayout="column">
              @for (square of colorColumn; track square.color) {
                <div class="square" [ngClass]="square.lightOrDark" (click)="selectColor(square.color)"
                  [ngStyle]="{ 'background-color': square.color }">
                  @if (selectedColor?.toLowerCase() === square.color.toLowerCase()) {
                    <i class="icon icon-check_clear" [ngClass]="square.lightOrDark"></i>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="ml-1">
        <div fxLayout="column">
          <div class="selected-color" [ngStyle]="{ 'background-color': selectedColor || selectedColorMissing, 'width.px': selectedColorWidth }">
          </div>
          <div class="selected-color-input mt-1">
            <input [disabled]="disabled" class="input" [class.is-error]="hasError" type="text" placeholder="---" [value]="selectedColor"
              [ngStyle]="{ 'width.px': selectedColorWidth }"
              (blur)="onSelectedColorChanged($event)"
              (focus)="hasError = false" />
          </div>
        </div>
      </div>
    </div>
    @if(hasError) {
      <div class="error-message mt-2">{{ 'COLOR-PICKER.INVALID-COLOR-ERROR' | translate }}</div>
    }
  </div>
}
